import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppFrame } from '@pasqal/core/ui/apps/AppFrame';
import '~/util/resetLegacyStorage';
import { init as initSentry } from '~/util/sentry';

import App from './App';

const consoleBanner = `
__________      .__
\\______   \\__ __|  |   ______ ___________
 |     ___/  |  \\  |  /  ___// __ \\_  __ \\
 |    |   |  |  /  |__\\___ \\\\  ___/|  | \\/
 |____|   |____/|____/____  >\\___  >__|
                          \\/     \\/
  _________ __            .___.__
 /   _____//  |_ __ __  __| _/|__| ____
 \\_____  \\\\   __\\  |  \\/ __ | |  |/  _ \\
 /        \\|  | |  |  / /_/ | |  (  <_> )
/_______  /|__| |____/\\____ | |__|\\____/
        \\/                 \\/
///////////////////////////////////////////
`;
console.log(`%c${consoleBanner}`, 'color: #00c887');

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <AppFrame appComponent={<App />} />
  </React.StrictMode>
);
